import type { TFuncKey } from 'i18next';
import type { ReactNode } from 'react';
import { useEffect } from 'react';

import LandingPageLayout from '@/Layout/LandingPageLayout';
import PoweredByFotofunken from '@/shared/components/PoweredByFotofunken';

import MarketingPanel from './MarketingPanel';
import styles from './SplitSignupLayout.module.scss';
import './tokens.css';

type SplitSignupLayoutProps = {
  readonly title: TFuncKey;
  readonly children: ReactNode;
};

const SplitSignupLayout = ({ title, children }: SplitSignupLayoutProps): JSX.Element => {
  // Scope-Marker auf <html> statt Body-Klasse: Helmet verwaltet die Body-Klassen
  // und würde manuell ergänzte Klassen beim nächsten Render überschreiben.
  useEffect(() => {
    // eslint-disable-next-line @silverhand/fp/no-mutation
    document.documentElement.dataset.fofuPage = 'split-signup';

    return () => {
      // eslint-disable-next-line @silverhand/fp/no-delete
      delete document.documentElement.dataset.fofuPage;
    };
  }, []);

  return (
    <div className={styles.split}>
      <MarketingPanel />
      <div className={styles.formColumn}>
        <div className={styles.card}>
          <LandingPageLayout title={title}>{children}</LandingPageLayout>
        </div>
        <PoweredByFotofunken className={styles.poweredBy} />
      </div>
    </div>
  );
};

export default SplitSignupLayout;
